import { render } from "./ambitions.vue?vue&type=template&id=46096abe&scoped=true"
import script from "./ambitions.vue?vue&type=script&lang=js"
export * from "./ambitions.vue?vue&type=script&lang=js"

import "./ambitions.vue?vue&type=style&index=0&id=46096abe&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46096abe"]])

export default __exports__